export default __webpack_public_path__ + "static/media/Star11.4c6afc64.svg";